module.exports = __webpack_public_path__ + "static/media/img-keepsakes.22b7e0a9.svg";